export default __webpack_public_path__ + "static/media/empty-report.1c46230c.svg";